import { Component, OnInit, Input } from '@angular/core';
import { SetService, JwtService, PageService } from 'ngx-block-core';
import { FormGroup } from '@angular/forms';
import { FormControlService } from "ngx-block-core";
import { HttpService } from 'ngx-block-core';
import { selectSize, eventTypeInput } from "../../../data/data";
import { filter, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-sucu04-weiget0090001',
  templateUrl: './sucu04-weiget0090001.component.html',
  styleUrls: ['./sucu04-weiget0090001.component.css']
})
export class Sucu04Weiget0090001Component implements OnInit {
  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() form: FormGroup;
  @Input() nzFormGroupData;
  @Input() nzLayout = 'horizontal'
  @Input() acl = 'cy';

  @Input() sets = {
    blockCode: "sucublock25",
    blockId: "",
    blockName: "单选框",
    layoutId: "",
    blockType: 'formBlock',
    blockChildType: '',
    versionCode: 10,
    attributes: ['form', 'nzFormGroupData', 'nzLayout'],
    events: [
      {
        label: "可用不可用",
        value: "isable",
        data: {
          setParams: ["不可用值", '可用值', '不可用时的默认值']
        }
      }
    ],
    sets: {
      acl: false
    },
    styles: {
      nzMode: 'default',//default|button
      nzSize: "default",
      nzButtonStyle: 'solid',//solid|outline
      nzRequired: false,
      nzHasFeedback: true,
      nzReadOnly: false,
      nzLayout: {
        nzLayout1: 0,
        nzLayout2: 8,
        nzLayout3: 0,
        nzLayout4: 16,
        nzAlign: 'left',
        nzMarginBottom: 3,
        nzLineHeight: 1.4,
        nzFontSize: 12
      },
      nzNoSee: false,
      nzExpandId: "",
    },
    datas: {
      nzDynamicData: false,
      nzEnterFilter: false,
      nzEnterFilterValues: "",
      nzDynamicSearch: {
        nzDynamicSql: "select columnA as value,columnB as label from tableNmae where ...",
      },
      nzData: [{ VALUE: '1', LABEL: '男' }, { VALUE: '2', LABEL: '女' }],
      nzEvents: [

      ],
      nzEventsDatas: {
      },
      nzLinkage: {
        nzUsed: false,
        nzEvents: [
          // {
          //   blockid:blockid,
          //   type:"value"//value,datasource
          // }
        ],//blockid
      },
      nzLinkageData: {
        nzDynamicSql: ""
      },
    }
  };

  setData = []

  constructor(
    public setService: SetService,
    private http: HttpService,
    private jwtService: JwtService,
    public formControlService: FormControlService,
    private pageService: PageService
  ) {
    // 实例化订阅对象
    this.subscript = new Subscription();
  }
  radioValue = ""
  // 声明订阅对象
  subscript: Subscription;

  ngOnInit() {
    console.log("ngOnInit-radio")
    this.baseInit();
    // if (this.sets.datas.nzData.length > 0 && this.nzFormGroupData['nzValue']['nzValue'] == "")
    //   this.radioValue = this.sets.datas.nzData[0].VALUE;
    // else if (this.nzFormGroupData['nzValue']['nzValue'] != "") {
    //   this.radioValue = this.nzFormGroupData['nzValue']['nzValue'];
    // }
    this.autoUpdate();
    this.Listening();
    console.log("ngOnInit-radio-valueChanges", this.blockid)
    this.subscript = this.form.get(this.nzFormGroupData.nzKey).valueChanges.pipe(
      //同valueChanges，不写也可
      // distinctUntilChanged(),
      //防抖时间，单位毫秒
      // debounceTime(50),
    ).subscribe((val) => {
      console.log("inputchange-radio", val + "]")

      console.log("ifEnterFilter", this.sets.datas.nzEnterFilter)
      if (this.sets.datas.nzEnterFilter) {
        console.log("nzEnterFilterValues", this.sets.datas.nzEnterFilterValues, this.form.get(this.nzFormGroupData.nzKey).value)
        if (this.sets.datas.nzEnterFilterValues == this.form.get(this.nzFormGroupData.nzKey).value) {
          console.log("ifEnterFilter2", this.ifEnterFilter)

          if (!this.ifEnterFilter) {
            this.ifEnterFilter = true;
            this.pageService.pageSpin[this.layoutid]['wait']++;
          }

        } else {
          console.log("ifEnterFilter3", this.ifEnterFilter)
          if (this.ifEnterFilter) {
            this.ifEnterFilter = false;
            this.pageService.pageSpin[this.layoutid]['wait']--;
          }
        }
      }

      console.log("valueChangesval", val + "]");
      this.formControlService.dataEvent(val, this.nzFormGroupData, this.blockid)


      //联动
      if (this.sets.datas.nzLinkage.nzUsed) {
        this.sets.datas.nzLinkage.nzEvents.forEach(element => {
          console.log("element", JSON.stringify(element));
          this.setService.sendEvent(element.blockid, "linkage" + element.type, { value: val })
        });
      }

      //事件
      this.sets.datas.nzEvents.forEach(element => {
        this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
          switch (element) {
            case 'sendSimpleEvent':
              // this.endEvent.push(element);

              switch (itemEvents['name']) {
                case "search":
                  if (val !== null && val !== undefined) {
                    let data = {};
                    if (itemEvents['param1'] === '' || itemEvents['param1'] === null || itemEvents['param1'] === undefined) itemEvents['param1'] = '=';
                    data[itemEvents['param0']] = [
                      {
                        "name": itemEvents['param1'],
                        "type": "",
                        "instruction": "",
                        "value1": val,
                        "value2": ""
                      }
                    ]
                    this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], data)
                    console.log("jsonsss", JSON.stringify(this.sets.datas.nzEventsDatas[element]), data)
                  }
                  break;
                case "updateNum":
                  this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], {
                    value:val,
                    upField:itemEvents['param0']
                  })
                  console.log("updateNum", JSON.stringify(this.sets.datas.nzEventsDatas[element]), {
                    value:val,
                    upField:itemEvents['param0']
                  })
                  break;

                default:


                  let senddata = { value: val };
                  try {
                    senddata['param0'] = itemEvents['param0'];
                    senddata['param1'] = itemEvents['param1'];
                    senddata['param2'] = itemEvents['param2'];
                  } catch (error) {

                  }
                  console.log("send", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                  this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                  break;
              }

              break;

            default:
              break;
          }
        });

      });
      console.log("inputchange-radio-end", val, this.blockid + "]")
    });
    console.log("ngOnInit-radio-valueChanges-end", this.blockid)
    if (this.sets.datas.nzEnterFilter) {

      if (this.sets.datas.nzEnterFilterValues == this.form.get(this.nzFormGroupData.nzKey).value) {
        if (!this.ifEnterFilter) {
          this.ifEnterFilter = true;
          this.pageService.pageSpin[this.layoutid]['wait']++;
        }
      }
    }
  }
  ifEnterFilter = false;
  autoUpdate() {

    //v3,升级自定义表单参数
    if (this.sets.versionCode < 3) {

      this.sets.blockCode = "sucublock25";

      this.sets.versionCode = 3;
    }
    //v4,升级自定义表单参数
    if (this.sets.versionCode < 4) {
      if (typeof this.sets.styles.nzNoSee == "undefined")
        this.sets.styles.nzNoSee = false;
      this.sets.versionCode = 4;
    }
    //v4,升级自定义表单参数
    if (this.sets.versionCode < 5) {
      this.sets.datas.nzEvents = [];
      this.sets.datas.nzEventsDatas = {};
      this.sets.versionCode = 5;
    }
    if (this.sets.versionCode < 7) {

      this.sets['events'] = [

        {
          label: "可用不可用",
          value: "isable",
          data: {
            setParams: ["不可用值", '可用值', '不可用时的默认值']
          }
        }
      ],


        this.sets.versionCode = 7;
    }
    if (this.sets.versionCode < 8) {

      this.sets['datas']['nzEnterFilter'] = false;
      this.sets['datas']['nzEnterFilterValues'] = "";

      this.sets.versionCode = 8;
    }
    if (this.sets.versionCode < 9) {

      this.sets.styles['nzExpandId'] = "";
      this.sets.versionCode = 9;
    }

    if (this.sets.versionCode < 10) {
      this.sets.datas['nzLinkage'] = {
        nzUsed: false,
        nzEvents: [

        ],
      };
      this.sets.datas['nzLinkageData'] = {
        nzDynamicSql: ""
      }

      this.sets.versionCode = 10;
      console.log("123");
    }

  }

  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormDataSource' },
              {
                name: 'nzFormSearchType', inputs: {
                  nzData: [{ value: '=', label: '=' }]
                }
              },
              { name: 'nzDynamicSearch', inputs: { nzNeedPage: false } },
              { name: 'nzLinkage', inputs: { nzBlockSets: this.sets } },
            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'radio',
                inputs: { nzText: "样式 : ", nzKeys: ['styles', 'nzMode'], nzData: [{ value: 'default', label: '默认' }, { value: 'button', label: '按钮' }] }
              },
              {
                name: 'radio',
                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize, nzPopContent: '仅对button样式有效' }
              },
              {
                name: 'radio',
                inputs: { nzText: "按钮样式 : ", nzKeys: ['styles', 'nzButtonStyle'], nzData: [{ value: 'outline', label: '描边' }, { value: 'solid', label: '填色' }], nzPopContent: '仅对button样式有效' }
              },
              {
                name: 'switch',
                inputs: { nzText: "只读 : ", nzKeys: ['styles', 'nzReadOnly'] }
              },
              {
                name: 'nzLayout'
              },
              {
                name: 'switch',
                inputs: { nzText: "显示必填* : ", nzKeys: ['styles', 'nzRequired'], nzPopContent: ['仅影响样式'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "校验图标 : ", nzKeys: ['styles', 'nzHasFeedback'], nzPopContent: ['校验状态的图标'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "表单忽视 : ", nzKeys: ['styles', 'nzNoSee'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.nzFormGroupData['nzSearchDataType'] = "noSee";
                    else
                      this.nzFormGroupData['nzSearchDataType'] = "string|array";
                  }
                }
              },

            ]
          }

        ]
      },
      {
        tabName: '表单',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormSet' },
            ]
          }
        ]
      },
      {
        tabName: '高级功能',
        datas: [

          {
            type: 'datas',
            data: [
              { name: "nzEvents", inputs: { eventType: eventTypeInput } },
              { name: "nzEnterFilter" }
            ]
          },
        ]
      }
    ]
  }
  baseInit() {

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.nzFormGroupData['nzSearchDataType'] = "string|array";
        if (this.sets.styles.nzNoSee == true)
          this.nzFormGroupData['nzSearchDataType'] = "noSee";
        if (this.nzFormGroupData['nzSearchType'] == 'null')
          this.nzFormGroupData['nzSearchType'] = "=";
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }

        this.pzListening()
      }
      else {//静态
        if (typeof this.sets == "string")
          this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
      }
    }
    if (this.sets.datas.nzDynamicData) {
      this.sets.datas.nzData = [];
      this.initSelected();
    }
  }
  ngOnDestroy() {
    console.log('000ngngOnDestroy执行了-radio', this.blockid);
    if (!this.static) this.setService.deleteEvent(this.blockid, 'pz')
    this.setService.deleteEvent(this.blockid);
    this.subscript.unsubscribe();
  }
  linkValue = {
    linkage: "",
    linkage2: "",
    linkage3: ""
  }
  sql = "";
  initSelected() {
    let sql = this.sets.datas.nzDynamicSearch.nzDynamicSql;
    console.log("initSelectedsql:" + sql);
    if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) sql = sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
    if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) sql = sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
    if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) sql = sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);
    console.log("数据表sql2:" + this.sets.datas.nzDynamicSearch.nzDynamicSql);
    console.log("数据表sq2:" + sql);
    let body = {
      "dynamicSql": this.pageService.replaceParam(this.jwtService.replaceUser(sql), this.layoutid),
      "pageSize": 100,
      "nowPage": 1,
      "paramMap": [
      ],
      "tableSort": [],
      "searchMap": {}
    }
    this.http.postHttp("/system/dynamicSql", body).subscribe(
      (data: any) => {
        this.sets.datas.nzData = [...data.data.list];
        if (this.sets.datas.nzData.length > 0 && this.nzFormGroupData['nzValue']['nzValue'] == "")
          this.radioValue = this.sets.datas.nzData[0].VALUE;
        else if (this.nzFormGroupData['nzValue']['nzValue'] != "") {
          this.radioValue = this.nzFormGroupData['nzValue']['nzValue'];
        }
      });
  }

  Listening() {
    console.log("Listening-radio", this.blockid)
    setTimeout(() => {
      this.setService.initEvent(this.blockid);
      this.setService.events[this.blockid].subscribe(
        data => {
          console.log("data-radio", JSON.stringify(data))
          let array0 = [];
          let array1 = [];
          switch (data['type']) {

            case 'isable':

              console.log("isable", data.datas)
              array0 = (data.datas.param0 + "").split(",");
              array1 = (data.datas.param1 + "").split(",");
              if (array0.indexOf(data.datas.value) >= 0) {
                //disable
                this.sets['styles']['nzReadOnly'] = true;
                if (data.datas.param2 != "")
                  this.form.get(this.nzFormGroupData.nzKey).patchValue(data.datas.param2);

              } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 == "") {
                // enable
                this.sets['styles']['nzReadOnly'] = false;
              }
              break;
            case 'linkagedatasource':
              console.log("linkagedatasource", data['datas']['value'])

              this.linkValue.linkage = data['datas']['value'];

              this.initSelected();

              break;
            case 'linkagedatasource2':
              console.log("linkagedatasource", data['datas']['value'])

              this.linkValue.linkage2 = data['datas']['value'];

              this.initSelected();
              break;
            case 'linkagedatasource3':
              console.log("linkagedatasource", data['datas']['value'])

              this.linkValue.linkage3 = data['datas']['value'];

              this.initSelected();

              break;
            case 'linkagesetValue':
              this.form.get(this.nzFormGroupData.nzKey).patchValue(data.datas.value)
              break;

            default:
              break;
          }


        }
      )
    }, !this.static ? 100 : 0);


  }
  pzListening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid, 'pz');
      this.setService.pzEvents[this.blockid].subscribe(data => {
        switch (data['type']) {
          case 'changeFormValid':
            this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
            break;
          case 'nzDynamicDatatrue':
            // this.sets.datas.nzData = [];
            break;
          case 'nzDynamicDatafalse':
            // this.sets.datas.nzDynamicSearch .nzValueName = 'value';
            // this.sets.datas.nzDynamicSearch.nzLabelName = 'label';
            // this.sets.datas.nzData = [];
            break;
          case 'refresh':
            this.initSelected();
            break;

          default:
            break;
        }
      }
      )
    }, 100);

  }


}
